import styled from 'styled-components';
import { useRootState } from '../../useRoot';
import Multilingual from '../../utils/Multilingual';

const StyledDiv = styled.div`
  padding: 3rem 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Index = ({ children }) => {
  const {
    loginInfo: { isLogin },
  } = useRootState();

  if (!isLogin) {
    return (
      <StyledDiv>
        <a href={`/login?done_url=${encodeURIComponent(window.location.href)}`}>
          {Multilingual(`COMMON.PLEASE_LOGIN_FIRST`)}
        </a>
      </StyledDiv>
    );
  }

  return <>{children}</>;
};

export default Index;
